// mui
import { isAutogeneratedRow } from '@mui/x-data-grid-premium';
// types
import { ReportColumnDto } from 'src/api';
// constants
import { numberAggregationModels } from '../constants/aggregation-model/number';

export function MarginColumn(index: number) {
  const column = {
    field: 'margin',
    headerName: 'Margin',
    description: 'The margin of the row',
    type: 'number',
    width: 150,
    index,
    groupable: true,
    availableAggregationFunctions: numberAggregationModels,
    headerAlign: 'center',
    align: 'right',
    valueGetter: (value: any, row: any) => {
      if (row && row.priceAmount !== undefined) {
        if (row.costPrice === undefined || row.costPrise === 0) {
          return 100;
        }
        const absoluteAmount = row.priceAmount - (row.discountAmount ?? 0) - (row.refunds ?? 0);
        const margin = absoluteAmount - row.costPrice;
        return (margin / absoluteAmount) * 100;
      }
      return null;
    },
    valueFormatter: (value: any, row: any) => {
      if (isAutogeneratedRow(row)) {
        return value;
      }
      if (value === undefined || value === null) {
        return null;
      }
      return `${value.toFixed(2)} %`;
    },
  } as ReportColumnDto<any, any, any>;
  return column;
}
